import React from 'react';
import '../styles/Home.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import HeroSection from './Homepages/HeroSection';
import WhyChooseUs from './Homepages/WhyChooseUs';
import WhatWeDo from './Homepages/WhatWeDo';

export default function Home() {
  return (
    <div className="home-page">
      {/* Hero Section */}
      <HeroSection />

      {/* Inner Content */}
      <WhatWeDo />

      {/* Why Choose Us Section */}
      <WhyChooseUs />
    </div>
  );
}
